"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = reducer;
exports.loadMeters = loadMeters;
exports.setSelectedMeter = setSelectedMeter;
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _meterReadingApi = require("../api/meterReadingApi");
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { (0, _defineProperty2.default)(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
// Actions
var LOAD_METER_PINS = 'api/reducer/LOAD_METER_PINS';
var SET_SELECTED_METER = 'api/reducer/SET_SELECTED_METER';

// Reducer
function reducer() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var action = arguments.length > 1 ? arguments[1] : undefined;
  var getPreselectedMeterNumber = function getPreselectedMeterNumber(meters) {
    if (meters[0]) {
      return meters[0].serialNumber;
    }
    return null;
  };
  switch (action.type) {
    case LOAD_METER_PINS:
      return _objectSpread(_objectSpread({}, state), {}, {
        data: action.data.innerData,
        meterSerialNumber: getPreselectedMeterNumber(action.data.innerData)
      });
    case SET_SELECTED_METER:
      return _objectSpread(_objectSpread({}, state), {}, {
        meterSerialNumber: action.data.serialNumber
      });
    default:
      return state;
  }
}

// Action Creators
function loadMeters(dispatch) {
  var resp = (0, _meterReadingApi.getAllMeterPins)();
  return resp.then(function (reponse) {
    dispatch({
      type: LOAD_METER_PINS,
      data: {
        innerData: reponse.data.content
      }
    });
  }).catch(function () {});
}
function setSelectedMeter(dispatch, serialNumber) {
  dispatch({
    type: SET_SELECTED_METER,
    data: {
      serialNumber: serialNumber
    }
  });
}